import type { OptionType } from '@atlaskit/select';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { SprintValue } from '@atlassian/jira-issue-shared-types/src/common/types/sprint-type.tsx';

export const getSuggestionsUrl = (autoCompleteUrl: string, query: string, projectKey?: string) => {
	const queryString = `${autoCompleteUrl}${encodeURIComponent(query)}`;
	if (projectKey !== null && projectKey !== undefined) {
		return `${queryString}&projectKey=${encodeURIComponent(projectKey)}`;
	}
	return queryString;
};

export const getSprintSuggestions = async (
	autoCompleteUrl: string,
	query: string,
	projectKey?: string,
) => performGetRequest(getSuggestionsUrl(autoCompleteUrl, query, projectKey));

export const mapOptionToSprint = (option: OptionType, boardId: string | null): SprintValue => ({
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	name: option.label as string,
	id: Number(option.value),
	boardId: Number(boardId),
	state: option.state,
});
